import * as z from "zod/v4";

export const getTextConciergeAnalytics = {
  name: "getTextConciergeAnalytics" as const,
  input: z.object({ teamId: z.string(), start: z.date(), end: z.date() }),

  output: z.object({
    outboundMessages: z.number(),
    uniqueRecipients: z.number(),
    customerReplies: z.number(),
    conversationsWithReply: z.number(),
    flaggedConversations: z.number(),
    timeSeries: z.array(
      z.object({ date: z.string(), outbound: z.number(), replies: z.number() }),
    ),
    analyticsSource: z.enum(["v1_snowflake", "v2_opensearch"]),
  }),
};
